import InteractiveMapCarousel from './InteractiveMapCarousel';

export default InteractiveMapCarousel;
